/* istanbul ignore file */
/**
 * Semantic theme configuration for NgKit.
 * Defines semantic color mappings, transitions, and form field styling.
 */

export const semanticConfig = {
  transitionDuration: '0s',
  focusRing: {
    width: '2px',
    style: 'solid',
    color: '{primary.color}',
    offset: '2px',
    shadow: 'none',
  },
  disabledOpacity: '0.6',
  iconSize: '1rem',
  anchorGutter: '0',
  primary: {
    25: '#f5faff',
    50: '#ecf5ff',
    100: '#d7e9ff',
    150: '#c4deff',
    200: '#a7ceff',
    250: '#93c2fe',
    300: '#79b1fb',
    350: '#61a1f8',
    400: '#4a91f4',
    450: '#3582f0',
    500: '#1a71ef',
    550: '#0d63de',
    600: '#0a57c5',
    650: '#074cad',
    700: '#043e8e',
    750: '#033477',
    800: '#01285d',
    850: '#01204b',
    900: '#001736',
    950: '#000d1e',
  },
  formField: {
    paddingX: '9px',
    paddingY: '7px',
    sm: {
      fontSize: '14px',
      paddingX: '8px',
      paddingY: '8px',
    },
    lg: {
      fontSize: '14px',
      paddingX: '8px',
      paddingY: '8px',
    },
    borderRadius: '{border.radius.none}',
    focusRing: {
      width: '0',
      style: '',
      color: 'transparent',
      offset: '0',
      shadow: '0 0 0 3px rgba(7, 76, 173, 0.6)',
    },
    transitionDuration: '{transition.duration}',
  },
  list: {
    padding: '0.125rem 0',
    gap: '0',
    header: {
      padding: '0.5rem 0.75rem 0.375rem 0.75rem',
    },
    option: {
      padding: '0.5rem',
      borderRadius: '0',
    },
    optionGroup: {
      padding: '0.5rem 0.75rem',
      fontWeight: '700',
    },
  },
  content: {
    borderRadius: '{border.radius.xs}',
  },
  mask: {
    transitionDuration: '0.15s',
  },
  navigation: {
    list: {
      padding: '0.25rem',
      gap: '0',
    },
    item: {
      padding: '0.75rem',
      borderRadius: '0',
      gap: '0.5rem',
    },
    submenu: {
      label: {
        padding: '0.25rem 0.5rem',
        font: {
          weight: 'normal',
        },
      },
    },
    submenuIcon: {
      size: '0.875rem',
    },
  },
  overlay: {
    select: {
      borderRadius: '{border.radius.none}',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
    popover: {
      borderRadius: '{border.radius.none}',
      padding: '0.75rem',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
    modal: {
      borderRadius: '{border.radius.none}',
      padding: '1.25rem',
      shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    },
    navigation: {
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
  },
};
